import clsx from "clsx";
import { useModalContext } from "../../contexts/modals";
import useIsMobile from "../../hooks/useIsMobile";

function Disclaimer(props: any) {
  const { addModal } = useModalContext();

  const isMobile = useIsMobile();

  const renderText = () => {
    return (
      <div>
        <p>Welcome to Alayna AI!</p>
        <br />
        <p>
          Before you begin using our AI-powered assistant, we want to make sure
          you fully understand the terms and conditions governing its use.
          Please take a moment to carefully read this disclaimer. By using our
          AI assistant, you acknowledge and agree to the following:
        </p>
        <br />
        <ol>
          <li>
            <strong>Information Accuracy and Reliability:</strong> Our AI
            assistant provides information based on its programming and training
            data up to the knowledge cutoff date, which is October 2023. While
            we strive to provide accurate and reliable information, we cannot
            guarantee the accuracy, completeness, or timeliness of the responses
            generated by the AI assistant. Users are responsible for verifying
            any information provided by the AI assistant for accuracy and
            reliability.
          </li>

          <li>
            <strong>No Substitute for Professional Advice:</strong>
            The information and responses generated by the AI assistant are
            intended for informational purposes only. They should not be
            considered a substitute for professional advice, guidance, or
            consultation. Teachers, educators, and users should seek the advice
            of qualified professionals when making educational decisions.
          </li>

          <li>
            <strong>Feedback and Improvements:</strong>
            We welcome user feedback to help improve the AI assistant's
            performance and accuracy. However, any suggestions or feedback
            provided by users do not imply an obligation on our part to
            implement changes or updates.
          </li>
        </ol>
        <br />
        <p>
          By using our AI assistant, you acknowledge that you have read,
          understood, and agreed to this disclaimer. If you do not agree with
          any part of this disclaimer, we recommend that you refrain from using
          the AI assistant.
        </p>
        <br />
        <p>
          Cues Technologies Inc. reserves the right to modify or update this
          disclaimer at any time without prior notice. It is your responsibility
          to review this disclaimer periodically for any changes.
        </p>
        <br />
        <p>
          If you have any questions or concerns about this disclaimer or the use
          of our AI assistant, please contact us at support@alayna.us.
        </p>
        <br />
        <p>Thank you for using Alayna!</p>
      </div>
    );
  };

  return (
    <div
      className={clsx(
        "text-[12px] text-gray-500",
        props.noPadding || isMobile ? "text-left" : "text-center"
      )}
    >
      Alayna may produce inaccurate information
      {"  "}
      <span
        className="cursor-pointer pl-2 text-[12px] font-bold text-black underline hover:text-gray-700"
        onClick={() => {
          addModal({
            content: renderText(),
            title: "Disclaimer",
            size: "md",
          });
        }}
      >
        Learn More
      </span>
    </div>
  );
}
export default Disclaimer;
